import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';

import dog1 from './assets/mccall.jpg';
import dog2 from './assets/slough.jpg';
import dog3 from './assets/layla.jpg';
import dog4 from './assets/swamp.jpg';
import dog5 from './assets/akutan.jpg';
import dog6 from './assets/tatina.jpg';
import dog7 from './assets/bog.jpg';
import dog8 from './assets/d1.jpeg';
import dog9 from './assets/d2.jpg';
import dog10 from './assets/d3.jpeg';
import dog11 from './assets/d44.jpg';
import dog12 from './assets/d5.jpeg';
import dog13 from './assets/d6.jpeg';
import dog14 from './assets/d7.jpg';
import dog15 from './assets/d8.jpg';
import dog16 from './assets/d9.jpeg';
import dog17 from './assets/d10.jpeg';
import dog18 from './assets/d11.jpeg';
import dog19 from './assets/d12.jpeg';
import dog20 from './assets/d13.jpeg';
import dog21 from './assets/d14.jpeg';
import dog22 from './assets/d16.jpeg';
import dog23 from './assets/d22.jpeg';
import dog24 from './assets/d23.jpeg';
import dog25 from './assets/d24.jpeg';
import dog26 from './assets/d25.jpeg';
import dog27 from './assets/d26.jpeg';
import dog28 from './assets/d27.jpeg';


const DogSlider = () => {
    const dogs = [
        {
            name: 'McCall',
            sponsored: true,
            sponsorName: 'Zion Bennett',
            image: dog1,
            description:
                `McCall is two years old and one of the most natural leaders I’ve had the pleasure to train. His drive and swift responsiveness set him apart and he consistently excels at the front of the team. No distractions or obstacles can break his focus, making him a true stand out from the start.`,
        },
        {
            name: 'Slough',
            sponsored: true,
            sponsorName: 'Shelly Silverberg',
            image: dog2,
            description:
                `Just like her dad(Iditarod champ, Gallo) she pulls like a dog three times her size. So full of energy, Slough is working on distinguishing the difference between work and play. Her confidence and discipline continue to mature as a young leader.`,
        },
        {
            name: 'Layla',
            sponsored: true,
            sponsorName: 'Lynn Whitcomb',
            image: dog3,
            description:
                'Pretty certain Layla has the zoomies 24/7. Being one of the biggest and most powerful dogs on the team, Layla brings excellence with her infinite energy and ferocious appetite. Layla is progressing as a leader and shows so much promise through her determination and drive.',
        },
        {
            name: 'Swamp',
            sponsored: true,
            sponsorName: 'Lindsay and Devin Burrup',
            image: dog4,
            description:
                'Swamp is one of the teams bigger goofballs, with a face that can run the full spectrum of expressions. He’s also one of the strongest pullers in the team, and when it’s go time, he’s all business. Lately, swamp has been spending more time at the front of the team and we’re excited to see how he’ll do in lead! ',
        },
        {
            name: 'Akutan',
            sponsored: true,
            sponsorName: 'Anna Milligan and Anari Burg',
            image: dog5,
            description:
                'Akutan is a delightful mix of silliness and politeness. With his stocky, muscular build, he’s a powerhouse on the team, serving as an exceptional wheel dog. Positioned right in front of the sled, he brings strength. After a run, Akutan loves to roll around until every inch of his body is spotless before heading back to his house.',
        },
        {
            name: 'Tatina',
            sponsored: true,
            sponsorName: 'Tracy Borton',
            image: dog6,
            description:
                '‘Tina’ is a hot topic around the yard. While she is stunning with her looks and elegant eyes, do not be fooled. Tina is the smallest on the team but certainly acts as the biggest. Nobody gets in her way, nor does she put up with nonsense or immaturity. She is a light footed, consistent worker, and has an all seriousness mindset (unless it’s time for a cuddle).',
        },
        {
            name: 'Bog',
            sponsored: true,
            sponsorName: "Cathy O'Connell",
            image: dog7,
            description:
                '‘Dog frog bog dog’ is a one-of-a-kind type of guy. What he lacks in size he makes up for with his eccentric personality. When preparing for a run, the sounds that emanate from the Bog are a mix between a scream/gargle/something you may hear out of The Shining. Once he is hooked on the line, he has a particular way of showing he’s ready, by laying as flat as he can to the ground, then shooting into the air with all the energy he can bring.',
        },

        {
            name: 'Godwin',
            sponsored: true,
            sponsorName: 'Shelly Silverberg',
            image: dog8,
            description:
                'Godwin is sleek, lean, and presents a funny smile upon greeting. Like his brothers McCall, Riggs and Clark, he is another exceptional leader on the team. On the line, he moves with a smooth, measured pace, and always thinks before he reacts. His thoughtful approach  leaves him with a calm presence and steady demeanor, and an awesome member of the team.',
        },

        {
            name: 'Riggs',
            sponsored: true,
            sponsorName: 'Kelly Ramey',
            image: dog9,
            description:
                '‘Bigg Riggs’ has an impressively large head and an even bigger personality. He’s the most vocal dog on the team, always eager to share his thoughts through his animated voice- and he’s never shy to remind you that he deserves your full attention. Despite his boastful chatter, there isn’t a mean bone in his body. Once he’s on the line, Riggs tones down his voice, turns on his focus, and gets right to work',
        },


        {
            name: 'Martin',
            sponsored: true,
            sponsorName: 'Caitlyn Stimson',
            image: dog10,
            description:
                '‘Fartin Martin’ is what I like to call an all-around good citizen. Initially, he wasn’t expected to take on a leadership role and started out as a steady team dog. However, his qualities have always been hard-driven, smart, kind, and exceptionally focused. The thought was, why wouldn’t I want a dog like that leading my team? At two years old of course Martin has become one of the teams strongest new leaders.',
        },


        {
            name: 'Swanson',
            sponsored: true,
            sponsorName: 'Nathan Weaks',
            image: dog11,
            description:
                'Swanson is a two year-old rising star on the team. What started out as a steady team dog, quickly changed into some really remarkable leadership. Swanson’s quick learning and eagerness have truly made him a stand out. He has infectious positivity, and is known for pouncing on the ground with both front feet when gearing up for a run, or anticipating food ',
        },


        {
            name: 'Butch',
            sponsored: true,
            sponsorName: 'Praire Daugherty',
            image: dog12,
            description:
                '‘Butcha’ is the first dog I discovered a true bond with. Starting when he was just a pup, his unwavering loyalty and exceptional leadership continue to make him my most reliable friend, and a mentor to the entire team. Now at 3 years old, Butch only continues to impress and inspire, and is nothing short of a truly special dog.',
        },


        {
            name: 'Thor',
            sponsored: true,
            sponsorName: 'Conrad Daugherty',
            image: dog13,
            description:
                '‘Mr Bean’ at 3 years old is the epitome of a gentle soul. With his ‘happy to see you’ personality, he always brings warmth and energy to the team. Though he once battled with his confidence as a leader, it’s inspiring to see him now leading and teaching his younger teammates with certainty.',
        },



        {
            name: 'Redoubt',
            sponsored: true,
            sponsorName: 'Tietje Paveglio',
            image: dog14,
            description:
                'Mr doubt stands tall, just like his namesake Mt Redoubt. He has a handsome gray and wolf like appearance and is incredibly driven and forward oriented. He’s all business on the line and brings unmatched energy and strength. At home his favorite thing to do, is prop his front feet up on his house, welcoming scratches from head to toe.',
        },



        {
            name: 'Augustine',
            sponsored: true,
            sponsorName: 'Scott Merrell',
            image: dog15,
            description:
                '‘The machine’ shares a stout build with his brother Akutan. With his cloudy gray coat and robust physique, he makes for a strong wheel dog. When you approach him, Augustine loves to dart into his house, convinced he’s invisible and then just as you get close, he’ll burst out with the perfect jump scare. He’s an incredibly hard worker with the most playful charm.',
        },



        {
            name: 'Condor',
            sponsored: true,
            sponsorName: 'Irene Lindquist',
            image: dog16,
            description:
                'Condor is a three year old and fantastic team player. When he hears his name, he responds with a very dramatic “woooWOOOO.” On the trail he is a steady and reliable worker, seamlessly creating good flow in the team. Condor has the most ferocious appetite and will never turn down a snack, making him a huge asset as we prepare for the Iditarod.',
        },


        {
            name: 'Blaze',
            sponsored: true,
            sponsorName: 'Carrie Stimson',
            image: dog17,
            description:
                '‘Bazer baze’ has been by my side since he was a yearling. Quiet and well mannered, he always aims to do the right thing. To strangers, he may come off as shy or strange, but once he builds trust, his outgoing personality shines through. Ag three years old, blazer is one of the top leaders on my team and a fantastic mentor to my younger dogs.',
        },

        {
            name: 'Haley',
            sponsored: true,
            sponsorName: 'Faye Wells',
            image: dog18,
            description:
                'Haley is the calm and thoughtful complete counterpart to her sister Layla. She relishes gentle affection, and savers every pet and stretch. Every move she makes is deliberate and graceful, reflecting her exceptional leadership qualities. Her drive to run is unwavering, and she is an absolute delight to have on the team.',
        },

        {
            name: 'Mud',
            sponsored: true,
            sponsorName: 'Bailey Schaeffer and Colton Sieh',
            image: dog19,
            description:
                '‘Mud the dud’ is one of the most interesting characters you’ll meet. Sweet as ever he’s got a heart of gold, but don’t let that fool you— when it’s time to run Mud transforms. Much like his brother Bog, the sound of his excitement can be mistaken for sounds out of a horror movie. Whenever we pause on the trail mud is the first to declare “It’s time to go!!!”',
        },


        {
            name: 'Marsh',
            sponsored: true,
            sponsorName: 'Robin Palmerson',
            image: dog20,
            description:
                '‘Marshmallow’ likes to put on a tough front to his teammates. This is in fact, all in act. He is actually one of the softest dogs on the team, quite bashful, and melts into a big mush pile when the attention is fully on himself. On the line Marsh has always been consistent, he has a strong and steady gait and is proving reliability as the season goes on.',
        },


        {
            name: 'Trigger',
            sponsored: true,
            sponsorName: 'Lara Kittelson and Troy Lane',
            image: dog21,
            description:
                '‘Big chig’ is a very humble and hard worker who never fails to present an eager and excited energy to the team. He’s an incredibly sweet guy, and never fails to sound the alarm if he feels something strange is in the air, keeping the yard safe through his awareness.',
        },


        {
            name: 'Zeus',
            sponsored: true,
            sponsorName: 'Julie Lindquist',
            image: dog22,
            description:
                'Zeus is three years old and has truly transformed overtime. Growing up, he was known as the yard bully and therefore did not have many friends. As he’s matured, Zeus has become a quiet bashful guy who simply wants to keep the peace. He’s an exceptional worker and a dependable member of the team. Zeus loves hanging out with his new friend Akutan, and enjoys the comfort of home.',
        },



        {
            name: 'Colt',
            sponsored: true,
            sponsorName: 'Donald Ramey',
            image: dog23,
            description:
                '‘Colt man’ is 3 years old with a personality all his own. He often flies under the radar. He’s humorous, quiet, slinky, and has a knack for appearing in the most unexpected places. On the trail he’s always vigilant, keeping a watchful eye on everything around him. When it’s time to make a turn, he bursts ahead with all the speed he’s got, making every turn an adventure. Colt man is truly a one-of-a-kind character on the team.',
        },

        {
            name: 'Skilak',
            sponsored: true,
            sponsorName: 'Charlie Daugherty',
            image: dog24,
            description:
                'Skilak is a true gentleman, and now the largest dog on the team. He’s still growing and becoming even more impressive. His size translates to remarkable strength, making him a great wheel, dog and team dog. With his rustic coloring and thick coat, Skilak is perfectly equipped to handle the coldest days on the trail.',
        },

        {
            name: 'Beaver',
            sponsored: true,
            sponsorName: 'Ed Kohn',
            image: dog25,
            description:
                'Sir Bevis is a Squirrley fella, boasting the curliest tail around. He loves ro prance with his head held high and still has that playful puppy spirit. While he’s still learning the ropes of maturity, he brings new growth with every day. Beaver’s spirited attitude and charm, make him an absolute joy on the team.',
        },

        {
            name: 'Kasilof',
            sponsored: true,
            sponsorName: 'Christy VanderWeide',
            image: dog26,
            description:
                '‘Kas’ is truly a pleasure to be around. Known for a steady and reliable nature, he’s always consistent in dependable. With an impressive appetite and love for cuddles, Kas remains a steadfast, delightful presence on the team.',
        },

        {
            name: 'Bacon',
            sponsored: true,
            sponsorName: 'Kari Atwood',
            image: dog27,
            description:
                'Bacon is a laid-back gentleman who has the smoothest gate on the team. He is a steady worker on the line, however, when it’s time to take a turn, his teammates might have a few complaints— he’ll let out a high-pitched scream, right into his partner’s ear, as if to yell “ DID YOU HEAR! TURN LEFT!!”. He’s got a lot in common with his mama, Astrid, who is the ultimate boss lady herself.',
        },

        {
            name: 'Clark',
            sponsored: true,
            sponsorName: 'Steve Wiseman',
            image: dog28,
            description:
                'Clark the fart is a character at that. Despite being one of the smallest on the team, he’s got the brains of a genius and impressive leadership skills. Much like his sister Tatina, Clark doesn’t tolerate nonsense and carries a tough, confident demeanor, no matter his size. When it comes to meal time, Clark levels up— literally shoving his face into his soup all the way up to his forehead',
        },


    ];

    const [index, setIndex] = useState(0);
    const [direction, setDirection] = useState(1);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
    const [loaded, setLoaded] = useState(false);

    // ✅ Preload all images
    useEffect(() => {
        const imagePromises = dogs.map(
            (dog) =>
                new Promise((resolve) => {
                    const img = new Image();
                    img.src = dog.image;
                    img.onload = resolve;
                    img.onerror = resolve; // still resolve to not block
                })
        );

        Promise.all(imagePromises).then(() => setLoaded(true));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const nextDog = () => {
        setDirection(1);
        setIndex((prev) => (prev + 1) % dogs.length);
    };

    const prevDog = () => {
        setDirection(-1);
        setIndex((prev) => (prev - 1 + dogs.length) % dogs.length);
    };

    // ✅ Animation variants (depend on direction)
    const slideVariants = {
        initial: (dir) => ({
            opacity: 0,
            x: dir === 1 ? 150 : -150,
        }),
        animate: {
            opacity: 1,
            x: 0,
        },
        exit: (dir) => ({
            opacity: 0,
            x: dir === 1 ? -150 : 150,
        }),
    };

    // ✅ If images aren’t loaded yet, show a temporary loader
    if (!loaded) {
        return (
            <div
                style={{
                    width: '100%',
                    textAlign: 'center',
                    color: '#000000',
                    padding: '100px 0',
                    fontFamily: "'Libre Baskerville', serif",
                    fontSize: '20px',
                }}
            >
                Loading the pack...
            </div>
        );
    }

    return (
        <div style={{ width: '100%', textAlign: 'center', marginTop: '20px' }}>
            <h2
                style={{
                    fontFamily: "'Libre Baskerville', serif",
                    fontSize: isMobile ? '36px' : '48px',
                    fontWeight: '700',
                    color: '#FFF2AF',
                    marginBottom: isMobile ? '15px' : '25px',
                }}
            >
                Meet the Pack!
            </h2>

            <p
                style={{
                    fontFamily: "'Libre Baskerville', serif",
                    fontSize: isMobile ? '18px' : '22px',
                    color: '#FFF2AF',
                    maxWidth: '800px',
                    margin: '0 auto',
                    marginBottom: isMobile ? '60px' : '80px',
                    lineHeight: 1.5,
                }}
            >
                Every dog on this team is between 2 and 3 years old, and 16 of these dogs will be selected for my team for Iditarod 2026!
            </p>

            <div
                style={{
                    position: 'relative',
                    width: '100%',
                    height: isMobile ? 'auto' : '800px',
                    backgroundColor: '#D9D9D9',
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    overflow: 'hidden',
                    marginBottom: isMobile ? '100px' : '200px',
                    boxShadow: '0 10px 25px rgba(0,0,0,0.3)',
                }}
            >
                <AnimatePresence mode="wait" custom={direction}>
                    <motion.div
                        key={index}
                        custom={direction}
                        variants={slideVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        transition={{ duration: 0.5, ease: 'easeInOut' }}
                        style={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        {/* 🐶 Image Section */}
                        <div style={{ width: isMobile ? '100%' : '55%', height: isMobile ? '320px' : '100%', position: 'relative' }}>
                            <img
                                src={dogs[index].image}
                                alt={dogs[index].name}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />

                            {/* 📱 Mobile Arrows */}
                            {isMobile && (
                                <>
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '10px',
                                            transform: 'translateY(-50%)',
                                            background: 'rgba(255,255,255,0.8)',
                                            borderRadius: '50%',
                                            width: '40px',
                                            height: '40px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
                                        }}
                                        onClick={prevDog}
                                    >
                                        <ChevronLeft size={22} color="#5FA89B" />
                                    </div>

                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            right: '10px',
                                            transform: 'translateY(-50%)',
                                            background: 'rgba(255,255,255,0.8)',
                                            borderRadius: '50%',
                                            width: '40px',
                                            height: '40px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
                                        }}
                                        onClick={nextDog}
                                    >
                                        <ChevronRight size={22} color="#5FA89B" />
                                    </div>
                                </>
                            )}
                        </div>

                        {/* 📜 Text Section */}
                        <div
                            style={{
                                width: isMobile ? '100%' : '45%',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                                padding: isMobile ? '0px' : '0 80px',
                                marginBottom: isMobile ? '60px' : '0px',
                            }}
                        >
                            <h2
                                style={{
                                    fontFamily: "'Libre Baskerville', serif",
                                    fontSize: isMobile ? '32px' : '40px',
                                    fontWeight: '700',
                                    color: '#000000',
                                    marginBottom: '25px',
                                }}
                            >
                                {dogs[index].name}
                            </h2>
                            <p
                                style={{
                                    fontFamily: "'Libre Baskerville', serif",
                                    fontSize: isMobile ? '18px' : '20px',
                                    color: '#000000',
                                    lineHeight: 1.6,
                                    marginBottom: '25px',
                                    padding: isMobile ? '15px' : '0px',
                                }}
                            >
                                {dogs[index].description}
                            </p>
                            {/* 🐾 Sponsor Button or Sponsor Name */}
                            {dogs[index].sponsored ? (
                                <div
                                    style={{
                                        fontFamily: "'Libre Baskerville', serif",
                                        fontSize: isMobile ? '20px' : '22px',
                                        color: '#000000',
                                        fontWeight: '600',
                                        marginTop: '20px',
                                    }}
                                >
                                    Sponsored by {dogs[index].sponsorName}
                                </div>
                            ) : (
                                // Uncomment this button when dog is available for sponsoring
                                <motion.button
                                    style={{
                                        padding: '15px 25px',
                                        borderRadius: '12px',
                                        backgroundColor: '#E94560',
                                        color: '#FFF',
                                        border: 'none',
                                        cursor: 'pointer',
                                        fontFamily: "'Libre Baskerville', serif",
                                        fontWeight: 600,
                                        marginTop: '10px',
                                        boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
                                        fontSize: isMobile ? '18px' : '20px',
                                    }}
                                    whileHover={{
                                        scale: 1.1,
                                        backgroundColor: '#FF5C7A',
                                        boxShadow: '0 6px 15px rgba(233,69,96,0.6)',
                                    }}
                                    whileTap={{ scale: 0.95 }}
                                    transition={{ type: 'spring', stiffness: 300, damping: 12 }}
                                    onClick={() => {
                                        const url = 'https://www.paypal.com/ncp/payment/E68UGTYK4B6KS';
                                        window.location.href = url;
                                    }}
                                >
                                    Sponsor {dogs[index].name} - $275
                                </motion.button>
                            )}

                        </div>
                    </motion.div>
                </AnimatePresence>

                {/* 🧭 Desktop Arrows */}
                {!isMobile && (
                    <>
                        <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                left: '25px',
                                background: 'rgba(255,255,255,0.8)',
                                borderRadius: '50%',
                                width: '55px',
                                height: '55px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                transform: 'translateY(-50%)',
                                boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
                            }}
                            onClick={prevDog}
                        >
                            <ChevronLeft size={30} color="#5FA89B" />
                        </div>

                        <div
                            style={{
                                position: 'absolute',
                                top: '50%',
                                right: '25px',
                                background: 'rgba(255,255,255,0.8)',
                                borderRadius: '50%',
                                width: '55px',
                                height: '55px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                transform: 'translateY(-50%)',
                                boxShadow: '0 3px 10px rgba(0,0,0,0.2)',
                            }}
                            onClick={nextDog}
                        >
                            <ChevronRight size={30} color="#5FA89B" />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default DogSlider;
